<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Klienci</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Klienci</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span :class="chevronFiltersClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content flex" v-show="isFiltersOpen">
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">Wybierz daty</label>
                <div class="col-sm-8">
                  <VueDatePicker
                    class="stats-daterangepicker2"
                    v-model="filterRangeDate"
                    multi-calendars
                    :format="format"
                    range
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">Status</label>
                <div class="col-sm-8">
                  <Multiselect
                    v-model="filterStatus"
                    :options="statusOptions"
                    placeholder="Wybierz status"
                    track-by="value"
                    label="name"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3 nopadding" v-if="canDisplaySites">
              <div class="form-group">
                <label class="control-label col-sm-3">Domena</label>
                <div class="col-sm-8">
                  <Multiselect
                    v-model="filterSitePk"
                    :options="sitesOptions"
                    placeholder="Wybierz domenę"
                    track-by="name"
                    label="name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Klienci</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddClient" to="/clients/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="5">5</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input
                      type="number"
                      v-model.number="serverOptions.page"
                      @change="
                        serverOptions.page = clampPage(serverOptions.page)
                      "
                    />
                    -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="selectPage(serverOptions.page - 1)"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="selectPage(serverOptions.page + 1)"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editClient"
                  alternating
                  multi-sort
                  show-index
                  border-cell
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text" @click="updateSort">
                      {{ header.text }}
                    </span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="
                        searchValue[
                          header.s_value ? header.s_value : header.value
                        ]
                      "
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand="item">
                    <div
                      class="wrapper wrapper-content animated fadeInRight"
                      v-if="clientObj.pk"
                    >
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="ibox float-e-margins">
                            <div class="ibox-title">
                              <h5>
                                Edycja klienta
                                {{ item.user.first_name }}
                                {{ item.user.last_name }}
                              </h5>
                            </div>

                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Adres e-mail
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.user.email"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Adres e-mail"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.user?.email"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.user.email[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Hasło
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.user.password"
                                      type="password"
                                      class="form-control inputClass"
                                      placeholder="Hasło"
                                      required="required"
                                    />
                                    <span class="help-block">
                                      Hasło musi mieć min. 8 znaków, zawierać co
                                      najmniej 1 wielką literę, 1 małą literę i
                                      1 cyfrę.
                                    </span>
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.user?.password
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.user.password[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Powtórz hasło
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.user.password2"
                                      type="password"
                                      class="form-control inputClass"
                                      placeholder="Powtórz hasło"
                                      required="required"
                                    />
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.user?.password2
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.user.password2[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Główne konto
                                  </label>
                                  <div class="col-sm-10">
                                    <Multiselect
                                      v-model="clientObj.main_account"
                                      mode="single"
                                      placeholder="Główne konto"
                                      track-by="name"
                                      label="name"
                                      :close-on-select="true"
                                      :searchable="true"
                                      :options="clientsOptions"
                                    >
                                    </Multiselect>
                                    <div
                                      v-if="errorsAdminData?.data?.main_account"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.main_account[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="hr-line-dashed"></div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Sklep
                                  </label>
                                  <div class="col-sm-10">
                                    <Multiselect
                                      v-model="clientObj.company_localization"
                                      mode="single"
                                      placeholder="Sklep"
                                      track-by="name"
                                      label="name"
                                      :close-on-select="true"
                                      :searchable="true"
                                      :options="countryList"
                                    >
                                    </Multiselect>
                                    <div
                                      v-if="errorsAdminData?.data?.main_account"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.main_account[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Imię
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.user.first_name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Imię"
                                      required="required"
                                    />
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.user?.first_name
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.user
                                            .first_name[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwisko
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.user.last_name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwisko"
                                      required="required"
                                    />
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.user?.last_name
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.user.last_name[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="hr-line-dashed"></div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa firmy
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.company_name"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa firmy"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.company_name"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.company_name[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    NIP
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.tax_id"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="NIP"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.tax_id"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.tax_id[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="hr-line-dashed"></div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Numer telefonu
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.telephone"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Numer telefonu"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.telephone"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.telephone[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Adres
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.address"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Adres"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.address"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.address[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Numer budynku
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.building_number"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Numer budynku"
                                      required="required"
                                    />
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.building_number
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data
                                            .building_number[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Numer mieszkania
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.suite_number"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Numer mieszkania"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.suite_number"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.suite_number[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Miasto
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.city"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Miasto"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.city"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.city[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Kod pocztowy
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.zip_code"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Kod pocztowy"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.zip_code"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.zip_code[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Kraj
                                  </label>
                                  <div class="col-sm-10">
                                    <Multiselect
                                      v-model="clientObj.country"
                                      mode="single"
                                      placeholder="Kraj"
                                      track-by="name"
                                      label="name"
                                      :close-on-select="true"
                                      :searchable="true"
                                      :options="countriesOptions"
                                    >
                                    </Multiselect>
                                    <div
                                      v-if="errorsAdminData?.data?.country"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.country[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="ibox float-e-margins">
                            <div class="ibox-title">
                              <h5>Dodatkowy adres dostawy</h5>
                            </div>

                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Nazwa firmy
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.company_name_2"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Nazwa firmy"
                                      required="required"
                                    />
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.company_name_2
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.company_name_2[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="hr-line-dashed"></div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Numer telefonu
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.telephone_2"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Numer telefonu"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.telephone_2"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.telephone_2[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Adres
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.address_2"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Adres"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.address_2"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.address_2[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Numer budynku
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.building_number_2"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Numer budynku"
                                      required="required"
                                    />
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.building_number_2
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data
                                            .building_number_2[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Numer mieszkania
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.suite_number_2"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Numer mieszkania"
                                      required="required"
                                    />
                                    <div
                                      v-if="
                                        errorsAdminData?.data?.suite_number_2
                                      "
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{
                                          errorsAdminData.data.suite_number_2[0]
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Miasto
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.city_2"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Miasto"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.city_2"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.city_2[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Kod pocztowy
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.zip_code_2"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Kod pocztowy"
                                      required="required"
                                    />
                                    <div
                                      v-if="errorsAdminData?.data?.zip_code_2"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.zip_code_2[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Kraj
                                  </label>
                                  <div class="col-sm-10">
                                    <Multiselect
                                      v-model="clientObj.country_2"
                                      mode="single"
                                      placeholder="Kraj"
                                      track-by="name"
                                      label="name"
                                      :close-on-select="true"
                                      :searchable="true"
                                      :options="countriesOptions"
                                    >
                                    </Multiselect>
                                    <div
                                      v-if="errorsAdminData?.data?.country_2"
                                      class="has-error"
                                    >
                                      <span class="help-block">
                                        {{ errorsAdminData.data.country_2[0] }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="ibox float-e-margins">
                            <div class="ibox-title">
                              <h5>Limity użytkownika</h5>
                            </div>

                            <div class="form-horizontal">
                              <div class="ibox-content">
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Ilość zamówień pobraniowych
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="
                                        clientObj.limitation.cod_quantity
                                      "
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Ilość zamówień pobraniowych"
                                      required="required"
                                    />
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Kwota netto zamówienia pobraniowego
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="clientObj.limitation.cod_amount"
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Kwota netto zamówienia pobraniowego"
                                      required="required"
                                    />
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="col-sm-offset-2 col-sm-10">
                                    <div class="checkbox checkbox-primary">
                                      <label>
                                        <input
                                          v-model="
                                            clientObj.limitation
                                              .is_many_addresses_available
                                          "
                                          type="checkbox"
                                        />
                                        <span>
                                          Możliwość ustawienia dowolnego adresu
                                          przesyłki dla płatności za pobraniem
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div class="hr-line-dashed"></div>

                                <div class="form-group">
                                  <div class="col-sm-offset-2 col-sm-10">
                                    <div class="checkbox checkbox-primary">
                                      <label>
                                        <input
                                          v-model="
                                            clientObj.limitation
                                              .is_provide_personal_parcel_pickup
                                          "
                                          type="checkbox"
                                        />
                                        <span>Odbiór osobisty przesyłek</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div class="hr-line-dashed"></div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Kwota limitu płatności z terminem
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="
                                        clientObj.limitation
                                          .payment_deadline_amount
                                      "
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Kwota limitu płatności z terminem"
                                      required="required"
                                    />
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label class="control-label col-sm-2">
                                    Ilość dni dla płatności z terminem
                                  </label>
                                  <div class="col-sm-10">
                                    <input
                                      v-model="
                                        clientObj.limitation
                                          .payment_deadline_days_num
                                      "
                                      type="text"
                                      class="form-control inputClass"
                                      placeholder="Ilość dni dla płatności z terminem"
                                      required="required"
                                    />
                                  </div>
                                </div>

                                <div class="form-group">
                                  <div class="col-sm-4 col-sm-offset-2">
                                    <button
                                      @click="cancel"
                                      class="btn btn-white"
                                    >
                                      Anuluj
                                    </button>
                                    <button
                                      v-if="canChangeClient"
                                      @click="saveEdit"
                                      class="btn btn-primary"
                                    >
                                      Zapisz
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-actions="item">
                    <button
                      @click.stop="clientDetails(item.pk)"
                      class="btn btn-primary btn-xs"
                      title="Szczegóły"
                    >
                      <i class="fa fa-list-alt"></i>
                    </button>
                    <button
                      v-if="canDeleteClient"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.user.email;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                  <template #item-user__is_active="item">
                    <font-awesome-icon
                      v-if="item.user.is_active"
                      icon="check"
                      class="table-helper-item"
                    />
                    <font-awesome-icon
                      v-else
                      icon="times"
                      class="table-helper-item"
                    />
                  </template>
                  <template #item-realized_orders_gross="item">
                    {{ formatCurrency(item.realized_orders_gross) }}
                  </template>
                  <template #item-realized_orders_count="item">
                    {{ item.realized_orders_count || 0 }}
                  </template>
                  <template #item-realized_orders_last_date="item">
                    {{ item.realized_orders_last_date || "-" }}
                  </template>
                  <template #item-realized_orders_first_date="item">
                    {{ item.realized_orders_first_date || "-" }}
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="5">5</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć ' + deleteName + ' ?'"
    @callbackOk="deleteUser(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import "@vueform/multiselect/themes/default.css";
import Modal from "../caffeprint/Modal.vue";
import { useRoute } from "vue-router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import router from "../../router/router";
import {
  getSiteValueFromCurrentUrl,
  hasSiteOptionValue,
} from "../../site-domain";
import { getPermittedSiteIds, hasPermission } from "../../permissions";
import { clientPermissionsConst } from "../../constants/clientConstants";

export default {
  name: "ClientsList",
  mixins: [],
  components: {
    Modal,
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    const clientsData = computed(() => store.getters.getClientsData);
    const clientData = computed(() => store.getters.getClientData);
    const updateClientData = computed(() => store.getters.getUpdateClientData);
    const clientDeleteData = computed(() => store.getters.getDeleteClientData);
    const adminClientsData = computed(() => store.getters.getAdminClientsData);
    const countriesData = computed(() => store.getters.getCountriesData);
    const clientsOptions = ref([]);
    const countriesOptions = ref([]);
    const filterRangeDate = ref();
    const filterStatus = ref(null);
    const filterSitePk = ref(null);
    const siteFilterInitialized = ref(false);

    const canAddClient = computed(() =>
      hasPermission(clientPermissionsConst.add)
    );
    const canChangeClient = computed(() =>
      hasPermission(clientPermissionsConst.update)
    );
    const canDeleteClient = computed(() =>
      hasPermission(clientPermissionsConst.delete)
    );
    // The domain filter only makes sense when the user may view clients on
    // more than one site.
    const permittedSiteIds = getPermittedSiteIds(clientPermissionsConst.view);
    const canDisplaySites = computed(() => permittedSiteIds.length > 1);

    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);

    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const statusOptions = ref([
      { name: "Aktywne", value: 1 },
      { name: "Nieaktywne", value: 0 },
    ]);

    const route = useRoute();

    const clientObj = ref({
      user: {
        email: "",
        password: "",
        password2: "",
      },
    });

    const countryList = ref([
      { name: "Polska", value: "PL" },
      { name: "Niemcy", value: "DE" },
    ]);
    let headers = [
      { text: "ID", value: "pk" },
      {
        text: "Imię",
        value: "user.first_name",
        sortable: true,
        search: true,
        s_value: "first_name",
      },
      {
        text: "Nazwisko",
        value: "user.last_name",
        sortable: true,
        search: true,
        s_value: "last_name",
      },
      {
        text: "Adres e-mail",
        value: "user.email",
        sortable: true,
        search: true,
        s_value: "email",
      },
      {
        text: "Główne konto",
        value: "main_account",
        sortable: true,
        search: true,
      },
      {
        text: "Sklep",
        value: "company_localization_display",
        sortable: true,
        search: true,
      },
      {
        text: "Grupa rabatowa",
        value: "discount_group",
        sortable: true,
        search: true,
      },
      {
        text: "Konto aktywne",
        value: "user__is_active",
        sortable: true,
        search: true,
      },
      {
        text: "Data dodania",
        value: "user.date_added",
        sortable: true,
        search: true,
      },
      {
        text: "Data modyfikacji",
        value: "user.date_modified",
        sortable: true,
        search: true,
      },
      {
        text: "Edytowano przez",
        value: "user.last_modified_by",
        sortable: true,
        search: true,
      },
      {
        text: "Wartość zamówień",
        value: "realized_orders_net",
        sortable: true,
        search: false,
      },
      {
        text: "Ilość zamówień",
        value: "realized_orders_count",
        sortable: true,
        search: false,
      },
      {
        text: "Data ostatniego zamówienia",
        value: "realized_orders_last_date",
        sortable: true,
        search: false,
      },
      {
        text: "Data pierwszego zamówienia",
        value: "realized_orders_first_date",
        sortable: true,
        search: false,
      },
      { text: "Data dodania", value: "user.date_added", sortable: true },
      { text: "Data modyfikacji", value: "user.date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "user.last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "user.created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const errorsAdminData = ref();
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(5);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const getClients = async () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      loading.value = true;
      let sort;

      if (serverOptions.value.sortBy) {
        let sortBy = serverOptions.value.sortBy.replace("user.", "user__");

        if (serverOptions.value.sortType === "desc") {
          sort = "-" + sortBy;
        } else {
          sort = sortBy;
        }
      }
      await store.dispatch("getClients", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        userPk: route.params?.pk,
        date: filterRangeDate.value,
        is_active: filterStatus.value,
        site_pk: filterSitePk.value,
      });
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const saveEdit = () => {
      if (!canChangeClient.value) {
        return;
      }
      errorsAdminData.value = undefined;
      store.dispatch("updateClient", clientObj.value);
    };

    const editClient = (globalIndex) => {
      errorsAdminData.value = undefined;
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getClient", { pk: items.value[localIndex].pk });
    };

    const deleteUser = (pk) => {
      if (!canDeleteClient.value) {
        return;
      }
      showModal.value = false;
      store.dispatch("deleteClient", {
        pk: pk,
        user: {
          is_active: false,
        },
      });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getClients();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterRangeDate.value = [];
      selectPage(1);
      serverOptions.value.sortBy = "";
      getClients();
    };

    const updateSort = () => {
      search.value = true;
    };

    const getMaxPages = () => {
      const total = Number(itemsAll.value) || 0;
      const perPage = Number(serverOptions.value.rowsPerPage) || 1;
      return Math.max(1, Math.ceil(total / perPage));
    };

    const clampPage = (page) => {
      const max = getMaxPages();
      if (!page || Number.isNaN(Number(page))) return 1;
      return Math.min(Math.max(1, Number(page)), max);
    };

    const selectPage = (page) => {
      serverOptions.value.page = clampPage(page);
    };

    store.dispatch("getAdminClients");
    store.dispatch("getCountriesList");
    store.dispatch("getSites");
    const sitesOptions = ref([]);
    const sitesData = computed(() => store.getters.getSitesData);

    watch(
      () => sitesData.value,
      function (newValue) {
        const raw = Array.isArray(newValue?.data?.results)
          ? newValue.data.results
          : Array.isArray(newValue?.data?.data)
          ? newValue.data.data
          : Array.isArray(newValue?.data)
          ? newValue.data
          : [];
        sitesOptions.value = raw
          .filter((s) => permittedSiteIds.includes(s.pk))
          .map((s) => ({ name: s.name, value: s.pk }));

        if (!hasSiteOptionValue(sitesOptions.value, filterSitePk.value)) {
          const defaultSiteValue = getSiteValueFromCurrentUrl(
            sitesOptions.value
          );
          if (defaultSiteValue !== null) {
            filterSitePk.value = defaultSiteValue;
          }
        }

        if (!siteFilterInitialized.value) {
          siteFilterInitialized.value = true;
          getClients();
        }
      }
    );

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    const clientDetails = (pk) => {
      router.push({ name: "ClientsDetails", params: { pk: pk } });
    };

    const format = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const formatCurrency = (value) => {
      if (value === null || value === undefined) return "-";
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
      }).format(value);
    };

    onMounted(() => {
      if (localStorage.getItem("clientsSearchValue") !== null) {
        searchValue.value = localStorage.getItem("clientsSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (
        localStorage.getItem("clientsRangeDate") !== null &&
        localStorage.getItem("clientsRangeDate") !== undefined
      ) {
        filterRangeDate.value = localStorage.getItem("clientsRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }
    });

    watch(
      () => [searchValue.value, filterRangeDate.value],
      function () {
        localStorage.setItem(
          "clientsSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "clientsRangeDate",
          JSON.stringify(filterRangeDate.value)
        );
        getClients();
      }
    );

    watch(
      () => filterStatus.value,
      function () {
        getClients();
      }
    );

    watch(
      () => adminClientsData.value,
      function (newValue) {
        newValue.data.results?.forEach((element) => {
          clientsOptions.value.push({
            name: "[" + element.pk + "] " + element.full_name,
            value: element.pk,
          });
        });
      }
    );

    watch(
      () => countriesData.value,
      function (newValue) {
        newValue.data.data?.forEach((element) => {
          countriesOptions.value.push({
            name: element.name_pl,
            value: element.code,
          });
        });
      }
    );

    watch(
      () => clientsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getClients();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    watch(
      () => clientData.value,
      function (newValue) {
        clientObj.value = newValue.data;
      }
    );

    watch(
      () => updateClientData.value,
      function (newValue) {
        if (newValue.status === 200) {
          errorsAdminData.value = undefined;
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
          cancel();
        } else {
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => clientDeleteData.value,
      function (newValue) {
        if (newValue.status === 200) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Klient zostal usunięty",
          });
        }
        getClients();
      }
    );

    watch(
      () => filterSitePk.value,
      function () {
        getClients();
      }
    );

    return {
      headers,
      clientsData,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      clientObj,
      errorsAdminData,
      canAddClient,
      canChangeClient,
      canDeleteClient,
      canDisplaySites,
      editClient,
      cancel,
      saveEdit,
      deleteUser,
      deleteName,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      countryList,
      clientsOptions,
      countriesOptions,
      selectPage,
      clampPage,
      getMaxPages,
      setRowsPerPage,
      filterRangeDate,
      filterStatus,
      statusOptions,
      filterSitePk,
      sitesOptions,
      isFiltersOpen,
      chevronFiltersClass,
      isMainOpen,
      chevronMainClass,

      format,
      formatCurrency,
      clientDetails,
    };
  },
  created() {
    const route = useRoute();
    if (route.params?.pk) {
      setTimeout(() => {
        document
          .querySelector(".can-expand.direction-left")
          .nextSibling.click();
      }, 500);
    }
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.statistic-box {
  text-align: center;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 20px;
}

.statistic-box h4 {
  margin-bottom: 10px;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
}

.statistic-box .number {
  font-size: 24px;
  font-weight: bold;
  color: #007bff;
}
</style>
